import { BaseAPI } from "../../BaseAPI";
import { v4 as uuidv4 } from 'uuid';
import * as environment from '../../../config/environment';

class SmsDogrulamaSaveAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "SmsDogrulamaSave";
    super(baseUrl);
  }


  saveSmsDogrulamaSaveSave(request: SmsDogrulamaSaveRequest){
    
    return this.post("", request, true);
   
  }

}
export default new SmsDogrulamaSaveAPI();
class SmsDogrulamaSaveRequest {
  cepTelefonNo?: string;
  referansNo?: string;
  tcKimlikNo?: string;
  vergiNo?: string;
  sicilNo?: number;
  aboneNo?: number;
  token?:string;
  isLogin?:boolean;
  isKayit?:boolean;

  constructor(
      cepTelefonNo?: string,
      tcKimlikNo?: string,
      vergiNo?: string,
      sicilNo?: number,
      aboneNo?: number,
      token?:string,
      isLogin?:boolean,
      isKayit?:boolean
  ) {
      let uniqueId = uuidv4();
      this.cepTelefonNo = cepTelefonNo;
      this.referansNo = uniqueId;
      this.tcKimlikNo = tcKimlikNo;
      this.vergiNo = vergiNo;
      this.sicilNo = sicilNo;
      this.aboneNo = aboneNo;
      this.token=token;
      this.isLogin=isLogin;
      this.isKayit=isKayit;
  }
}
export { SmsDogrulamaSaveRequest };